import ActionTypes from '../../ActionTypes';
import recipientService from '../../services/RecipientService';
import { createClient } from '../../services/MessageTemplatesService';
import gql from 'graphql-tag';
import { getSession } from '../../services/SessionService';
import { Recipient } from '../../types';
import { RecipientError } from '../../reduxTypes';
import { Action } from 'redux';
import { getQueryStringValueByKey } from '../../helpers/queryStringUtils';

export interface RecipientSuccessAction extends Action {
    recipient: Recipient;
    conversationId: number;
}

export interface RecipientErrorAction extends Action {
    error: RecipientError;
}

export interface RecipientUpdateStatusAction extends Action {
    conversationId: number;
}

function loadingRecipient() {
    return {
        type: ActionTypes.RECIPIENT_LOADING
    };
}

function loadRecipientSuccess(recipient: Recipient, conversationId: number): RecipientSuccessAction {
    return {
        type: ActionTypes.RECIPIENT_LOADED,
        recipient,
        conversationId
    };
}

export function updateRecipientStatus(conversationId: number): RecipientUpdateStatusAction {
    return {
        type: ActionTypes.RECIPIENT_CHANGE_STATUS,
        conversationId
    };
}

function loadRecipientError(error: TypeError): RecipientErrorAction {
    return {
        type: ActionTypes.RECIPIENT_LOAD_ERROR,
        error
    };
}

export function loadRecipient(conversationId: number, shouldShowLoading: boolean = true) {
    return async function loadRecipientAction(dispatch) {
        shouldShowLoading && dispatch(loadingRecipient());

        try {
            const session = await getSession();
            const { details: { conversation: { recipient } } } = await recipientService(session, conversationId);

            const dealerId = parseInt(session.dealer_id, 10);
            const callListId = getQueryStringValueByKey('calllist_id') && parseInt(getQueryStringValueByKey('calllist_id'), 10);
            const supportedLanguages = await createClient(session).query({
                query: gql`{
                messageLanguages(dealerId: ${dealerId}, callListId: ${callListId}) {
                    messageLanguages
                }
            }`});

            // console.log(supportedLanguages);
            const preferredLanguage = supportedLanguages.data.messageLanguages.messageLanguages[0];
            const { language } = recipient;
            if (language === null || (language && language.length > 3)) {
                recipient.language = preferredLanguage;
            }

            dispatch(loadRecipientSuccess(recipient, conversationId));
        } catch (error) {
            dispatch(loadRecipientError(error));
        }
    };
}



// WEBPACK FOOTER //
// ./src/sections/Recipient/RecipientActions.ts